import {HeaderContext} from "@components/Contexts/HeaderContext"
import ButtonComponent from "@components/Theme/Button/Button"
import Typography, {Size} from "@components/WebsiteRevamp/Typography/Typography"
import checkIfLinkIsCurrent from "@components/WebsiteRevamp/utils/checkIfLinkIsCurrent"
import ExternalIcon from "@components/icons/ExternalIcon"
import {MenuModuleType} from "@hooks/WorkWithJson/GetComponentDataByKey/GetComponentDataByKeyTypes"
import {useRouter} from "next/router"
import React, {useContext, useEffect} from "react"
import {CSSTransition, TransitionGroup} from "react-transition-group"

import HeaderHoverOld from "../HeaderHover/HeaderHoverOld/HeaderHoverOld"

import styles from "./HeaderLink.module.scss"

type Props = {
	data: MenuModuleType
	asLink?: boolean
	linkClassName?: string
	isScrolled: boolean
	last?: "last"
	asExpanded?: {
		setIsShown: (navBarIndex: number) => void
		isShown: number
		navBarIndex: number
	}
}

const HeaderLink = (props: Props) => {
	const asExpanded = props.asExpanded
	const {theme} = useContext(HeaderContext)

	const router = useRouter()

	const {current} = checkIfLinkIsCurrent(
		router.asPath,
		props.data.link,
		props.data.subLinksSelect,
	)

	const active = current ? styles.active : ""

	let activeExpanded = ""

	props.data.children?.map((element: MenuModuleType) => {
		const {current, parent} = checkIfLinkIsCurrent(
			router.asPath,
			element.link,
			element.subLinksSelect,
		)

		if (current || parent) {
			activeExpanded = styles.active
		}
		return element
	})

	useEffect(() => {
		asExpanded?.setIsShown(-1)
	}, [router])

	const external = props.data.link?.includes("http")

	return (
		<li
			className={styles.navListItem}
			// onMouseLeave={() => asExpanded?.setIsShown(-1)}
		>
			{props.asLink && (
				<ButtonComponent
					className={`${styles.link} ${styles[theme]} ${
						external ? styles.external : ""
					}  ${active} ${props.linkClassName} ${props.data.brand}`}
					link={props.data.link}
					size={"small"}
					asLink
					withoutTarget
				>
					<span
						className={`${styles.linkWithImageContainer}`}
						style={{
							paddingLeft: 0,
						}}
					>
						<Typography
							content={props.data.menuTitle}
							size={Size.XS}
							// contrast
							noPadding
						/>
					</span>
					{external && (
						<ExternalIcon
							className={`${styles.svgIcon} ${
								styles[
									props.data.menuLinkIconSvg?.src
										? "withIcon"
										: ""
								]
							} `}
						/>
					)}
				</ButtonComponent>
			)}

			{asExpanded && (
				<>
					<ButtonComponent
						buttonType={"text"}
						className={`${styles.link} ${styles[theme]}  ${
							styles.expanded
						} ${
							asExpanded.isShown === asExpanded.navBarIndex
								? styles.shown
								: ""
						}  ${props.linkClassName} ${activeExpanded} `}
						size={"small"}
						onMouseEnter={() => {
							asExpanded.setIsShown(asExpanded.navBarIndex)
						}}
					>
						<Typography
							content={props.data.menuTitle}
							className={styles.linkTitle}
							size={Size.XS}
							fontWeight={400}
							// contrast
							noPadding
						/>
					</ButtonComponent>
					<TransitionGroup>
						{asExpanded.isShown === asExpanded.navBarIndex &&
							props.data.children && (
								<CSSTransition
									key={asExpanded.navBarIndex}
									classNames={{
										enter: styles.listEnter,
										enterActive: styles.listEnterActive,
										exit: styles.listExit,
										exitActive: styles.listExitActive,
									}}
									timeout={300}
								>
									<HeaderHoverOld
										last={props.last}
										data={props.data.children}
										// isScrolled={props.isScrolled}
									/>
								</CSSTransition>
							)}
					</TransitionGroup>
				</>
			)}
		</li>
	)
}

export default HeaderLink
